import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import fileDownload from "js-file-download";

// Component
import CollectionApproval from "./CollectionApproval";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";

// Action
import {
  searchCollectionApprovalAction,
  downloadCollectionApprovalAction,
  approveCollectionPaymentAction,
  rejectCollectionPaymentAction,
  viewCollectionEvidenceAction,
  getCollectionBanksAction,
} from "./CollectionApprovalAction";

// Redux actions that carry the selected minimart or loan to its page
import { setMiniMartDetailsAction } from "../CiInterface/CIInterfaceActions";
import { setLoanDetailsIDAction } from "../LoanDetails/LoanDetailsAction";

// Constants
import { OPERATION_STATUS } from "../../config/axios.init";
import { ROUTES } from "../../constants/routeConstants";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Utility
import Utility from "../../utils/Utility";

class CollectionApprovalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      numberOfPages: 0,
      prevRequestData: null,
      banks: [],
      evidenceUrl: "",
      evidenceFileType: "",
      evidenceLoading: false,
      isLoading: false,
      showNotification: false,
      notificationLevel: "",
      notificationMessage: "",
    };
  }

  componentDidMount() {
    this.loadBanks();
  }

  // offered to the approver for a request the collector raised without a bank
  loadBanks = () => {
    getCollectionBanksAction((response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({ banks: response.data.data });
      }
    });
  };

  // the screen asks for its own first page, filters and page size live there
  onSearch = (requestData) => {
    this.setState({ isLoading: true, prevRequestData: requestData });
    searchCollectionApprovalAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          requests: response.data.data.requests,
          numberOfPages: response.data.data.np,
          isLoading: false,
        });
      } else {
        this.setState({ requests: [], numberOfPages: 0, isLoading: false });
        this.notify("error", response.error.message);
      }
    });
  };

  onDownload = (fileType, requestData) => {
    this.setState({ isLoading: true });
    downloadCollectionApprovalAction(fileType, requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        if (Utility.checkBlobTypeForFileDownload(response.data.type)) {
          fileDownload(
            response.data,
            Strings("collectionApproval") +
              "-" +
              Utility.getReportFormattedDateString(
                Utility.convertDateIntoMiliSeconds(new Date())
              ) +
              Utility.getFileType(fileType)
          );
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          this.notify("error", Strings("NoRecordsFound"));
        }
      } else {
        this.setState({ isLoading: false });
        this.notify("error", response.error.message);
      }
    });
  };

  onDecision = (approvalId, isApproval, waiveLateFee, note, bankId) => {
    this.setState({ isLoading: true });
    const action = isApproval
      ? approveCollectionPaymentAction
      : rejectCollectionPaymentAction;
    action({ approvalId, waiveLateFee, note, bankId }, (response) => {
      this.setState({ isLoading: false });
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.notify(
          "success",
          isApproval
            ? Strings("paymentApproved")
            : Strings("paymentRejected")
        );
        // show the same page again, the decided request drops out of a pending filter
        if (this.state.prevRequestData) {
          this.onSearch(this.state.prevRequestData);
        }
      } else {
        this.notify("error", response.error.message);
      }
    });
  };

  onViewEvidence = (evidenceId) => {
    this.setState({ evidenceLoading: true, evidenceUrl: "", evidenceFileType: "" });
    viewCollectionEvidenceAction({ evidenceId }, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          // the server sends the storage link encrypted, like every other receipt view
          evidenceUrl: Utility.getDecryptedData(
            response.data.data.transferReceiptUrl
          ),
          evidenceFileType: response.data.data.fileType,
          evidenceLoading: false,
        });
      } else {
        this.setState({ evidenceLoading: false });
        this.notify("error", response.error.message);
      }
    });
  };

  onClearEvidence = () => {
    this.setState({ evidenceUrl: "", evidenceFileType: "", evidenceLoading: false });
  };

  notify = (level, message) => {
    this.setState({
      showNotification: true,
      notificationLevel: level,
      notificationMessage: message,
    });
  };

  closeNotification = () => {
    this.setState({ showNotification: false });
  };

  // the minimart page reads its minimart from the store, as it does from the loan page
  onOpenMinimart = (minimartId) => {
    this.props.setMiniMartDetailsAction({ id: minimartId });
    this.props.history.push(ROUTES.MINIMART_DETAILS);
  };

  // the loan page is keyed by the application id, the other fields only save it a lookup
  onOpenLoan = (request) => {
    this.props.setLoanDetailsIDAction({
      applicationId: request.applicationId,
      loanId: request.loanId,
      loanType: request.loanType,
      status: request.loanStatus,
    });
    this.props.history.push(ROUTES.LOAN_APPLICATION_DETAILS);
  };

  render() {
    return (
      <>
        <LoadingModal showLoadingModal={this.state.isLoading} />
        {this.state.showNotification && (
          <UserNotification
            key={this.state.notificationMessage}
            userNotificationObj={{
              level: this.state.notificationLevel,
              message: this.state.notificationMessage,
            }}
            onClose={this.closeNotification}
          />
        )}
        <CollectionApproval
          requests={this.state.requests}
          numberOfPages={this.state.numberOfPages}
          banks={this.state.banks}
          onSearch={this.onSearch}
          onDownload={this.onDownload}
          evidenceUrl={this.state.evidenceUrl}
          evidenceFileType={this.state.evidenceFileType}
          evidenceLoading={this.state.evidenceLoading}
          onDecision={this.onDecision}
          onViewEvidence={this.onViewEvidence}
          onClearEvidence={this.onClearEvidence}
          onOpenMinimart={this.onOpenMinimart}
          onOpenLoan={this.onOpenLoan}
        />
      </>
    );
  }
}

const mapStateToProps = () => ({}); //NOSONAR

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { setMiniMartDetailsAction, setLoanDetailsIDAction },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionApprovalContainer);
